import { Checkbox, FormControl, FormControlLabel, FormHelperText, SxProps } from '@mui/material'
import React from 'react'
import { FieldValues, useController, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FormErrorHelperText } from '../FormErrorHelperText'
import { FormControls } from '../types'

export const FormInputCheckbox = <T extends FieldValues>({
  name,
  label,
  required = false,
  sx = {},
}: FormControls<T> & { sx?: SxProps }): JSX.Element => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: { required: { value: required, message: t('field.requiredHelperText') } },
  })

  return (
    <FormControl error={!!error} sx={{ ...sx }}>
      <FormControlLabel
        control={
          <Checkbox
            {...field}
            checked={!!field.value}
            onChange={(e) => field.onChange(e.target.checked)}
            sx={{
              color: 'grey.400',
              '&.Mui-checked': {
                color: 'primary.main',
              },
              padding: '4px 8px',
            }}
          />
        }
        label={label}
        sx={{
          margin: 0,
          alignItems: 'center',
        }}
      />
      {error?.message && (
        <FormHelperText>
          <FormErrorHelperText error={error.message} />
        </FormHelperText>
      )}
    </FormControl>
  )
}
